var map = {
	"./calls/calls.module": [
		"./src/app/layout/calls/calls.module.ts",
		"default~calls-calls-module~layout-layout-module~leads-leads-module",
		"default~calls-calls-module~layout-layout-module",
		"common",
		"calls-calls-module"
	],
	"./layout/layout.module": [
		"./src/app/layout/layout.module.ts",
		"default~calls-calls-module~layout-layout-module~leads-leads-module",
		"default~layout-layout-module~leads-leads-module",
		"default~layout-layout-module~login-login-module",
		"default~calls-calls-module~layout-layout-module",
		"common",
		"layout-layout-module"
	],
	"./leadAssignment/lead-assignment.module": [
		"./src/app/layout/leadAssignment/lead-assignment.module.ts",
		"leadAssignment-lead-assignment-module"
	],
	"./leads/leads.module": [
		"./src/app/layout/leads/leads.module.ts",
		"default~calls-calls-module~layout-layout-module~leads-leads-module",
		"default~layout-layout-module~leads-leads-module",
		"common",
		"leads-leads-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"default~layout-layout-module~login-login-module",
		"common",
		"login-login-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;